import { IComponentOptions, IController } from 'angular';
import { IBalance } from '../../../../core/services/payment/payment.service';
import { User } from '../../../../core/entities/user';
import './dashboard-topbar.component.scss';
import { UserService } from '../../../../core/services/user/user.service';
import { VacancyService } from '../../../../core/services/vacancy/vacancy.service';

class DashboardTopbarController implements IController {
  static $inject = ['UserService', 'VacancyService'];
  user: User;
  balance: IBalance;
  profileLink: string;
  status = {
    candidates: {
      all: null,
      online: null
    },
    employers: {
      all: null,
      online: null
    },
    vacancies: {
      all: null,
      active: null
    }
  };

  constructor( private userService: UserService,
               private vacancyService: VacancyService) {
  }

  $onInit() {
    this.userService.getUsersCountersWithOnline()
      .then(( data ) => {
        this.status.candidates.all = data.usersCounters.candidates;
        this.status.employers.all = data.usersCounters.employers;
        this.status.candidates.online = data.online.candidates;
        this.status.employers.online = data.online.employers;
      });
    this.vacancyService.getActiveVacanciesCount()
      .then((data) => {
        this.status.vacancies.all = data.all;
        this.status.vacancies.active = data.count;
      });
  }
}

export const DashboardTopbarComponent: IComponentOptions = {
  controller: DashboardTopbarController,
  template: require('./dashboard-topbar.component.html'),
  bindings: {
    user: '<',
    balance: '<'
  }
};



// WEBPACK FOOTER //
// ./app/states/dashboard/components/dashboard-topbar/dashboard-topbar.component.ts